import { useEffect, useState } from "react";
import ApiServices, { API_URL } from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import { Link, useParams } from "react-router-dom";
import moment from "moment/moment";
import * as qs from "qs";
import Pagination from "../../utils/Pagination";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import AttachmentIcon from '@mui/icons-material/Attachment';

export default function ManageMaterial({ title }) {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const isOpen = useSelector((state) => state.modal.isOpen);
    const { batchId } = useParams();
    const [materials, setMaterials] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalData, setTotalData] = useState(0);

    useEffect(() => {
        if (isOpen === false) {
            fetchMaterials();
        }
    }, [isOpen, currentPage, itemsPerPage, batchId]);

    const fetchMaterials = () => {
        dispatch(showLoader());
        ApiServices.apiRequest("getMaterial", { batchId: batchId, limit: itemsPerPage, pageno: currentPage + 1 })
            .then((res) => {
                // console.log(res.data.data);
                
                if (res.data.success) {
                    let totalData = res.data.total ? res.data.total : 0;
                    setTotalData(totalData);
                    let totalPages = Math.ceil(totalData / itemsPerPage);
                    setTotalPages(totalPages);
                    setMaterials(res.data.data);
                    console.log("material data is:", res.data.data)
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message ? err?.message : "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    };

    const getDate = (date) => {
        return moment(date).format("Do MMM YY HH:MM");
    };

    const handlePageChange = (event, newPage) => {
        console.log(newPage);
        
        setCurrentPage(newPage);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(parseInt(event.target.value, 10));
    };

    const postMaterial = (id) => {
        let data = {
            _id: id,
        }
        dispatch(showModal("StatusModal", qs.stringify(data), "postMaterial", 'post'))
    }

    const handleDeleteMaterial = (id) => {
        dispatch(showLoader());
        ApiServices.apiRequest("deleteMaterial", { _id: id })
            .then((res) => {
                if (res.data.success) {
                    toast.success("Material deleted successfully");
                    fetchMaterials();
                } else {
                    toast.error(res.data.message || "Delete failed");
                }
            })
            .catch((err) => {
                toast.error(err?.message ? err?.message : "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    };

    const getAttachmentName = (filename) => {
        let parts = filename.split('/');
        let actutalName = parts.slice(4).join('/');
        return actutalName;
    }

    return (
        <>
            <div className="container">
                <div className="page-inner">
                    {loading && !isOpen ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="d-flex justify-content-between align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                <div className="col-md">
                                    <h3 className="fw-bold mt-3">{title}</h3>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        onClick={() => {
                                            dispatch(showModal("AddMaterial"));
                                        }}
                                        className="btn btn-primary btn-round"
                                    >
                                        Add Material
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <div className="container">
                                <div className="row">
                                    <div className="accordion" id="accordionExample">
                                        <div className="col-sm-12 text-capitalize">
                                            {materials?.length > 0 ? (
                                                materials?.map((el, index) => (
                                                    <div className="accordion-item my-2" key={index}>
                                                        <h2 className="accordion-header">
                                                            <button
                                                                className="accordion-button align-items-center py-1 d-flex justify-content-between"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${index}`}
                                                            >
                                                                {el?.title}
                                                                <div className="text-muted d-flex align-items-center fs-6">
                                                                    
                                                                    <span className="me-3">
                                                                        Posted By: {el?.trainerId?.name || "Unknown"}
                                                                    </span>
                                                                    <span>Posted {getDate(el?.PostedAt || el?.createdAt)}</span>
                                                                    <div className="dropdown">
                                                                        <IconButton type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <MoreVertIcon />
                                                                        </IconButton>
                                                                        <ul className="dropdown-menu">
                                                                            {el?.ishide && (
                                                                                <li>
                                                                                    <a
                                                                                        className="dropdown-item"
                                                                                        href="#"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            postMaterial(el._id);
                                                                                        }}
                                                                                    >
                                                                                        Post
                                                                                    </a>
                                                                                </li>
                                                                            )}
                                                                            <li>
                                                                                <a
                                                                                    className="dropdown-item"
                                                                                    href="#"
                                                                                    onClick={() => {
                                                                                        dispatch(showModal("EditMaterial", { _id: el._id }));
                                                                                    }}
                                                                                >
                                                                                    Edit
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a
                                                                                    className="dropdown-item"
                                                                                    href="#"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        handleDeleteMaterial(el._id);
                                                                                    }}
                                                                                >
                                                                                    Delete
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </h2>
                                                        <div
                                                            id={`collapse${index}`}
                                                            className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionExample"
                                                        >
                                                            <div className="accordion-body">
                                                                <div className="d-flex justify-content-between">
                                                                    <div>{el?.description}</div>
                                                                    <div className="attachments">
                                                                        {el.attachments?.map((file, idx) => (
                                                                            <div key={idx} className="d-flex align-items-center">
                                                                                <Link to={`${file}`} target="_blank" rel="noopener noreferrer">
                                                                                    <AttachmentIcon sx={{ ml: 1, color: 'grey' }} />
                                                                                    <span className="ms-2">{getAttachmentName(file)}</span>
                                                                                </Link>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <h1>No Material Present!!</h1>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        count={totalData}
                                        page={currentPage}
                                        itemsPerPage={itemsPerPage}
                                        onPageChange={handlePageChange}
                                        onItemsPerPageChange={handleItemsPerPageChange}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );

}
